// Modules
import styled from "styled-components"
import { rgba } from "polished"

// Constants
import colors from "~constants/colors"

interface Props {
  $customMarginBottom?: string
}

export const InputContainer = styled.div<Props>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.$customMarginBottom || "20px"};

  > .label {
    color: ${colors.gray4};
    display: block;
    letter-spacing: 0.76px;
    line-height: 100%;
    margin-bottom: 5px;
  }

  > .input-bottom {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  .info-copy,
  .input-limit,
  .error-message {
    display: block;
    font-size: 11px;
    height: 10px;
    letter-spacing: 0.21px;
    line-height: 10px;
    margin-top: 5px;
  }

  .info-copy,
  .input-limit {
    color: ${colors.gray4};
  }

  .error-message {
    color: ${colors.red};
  }
`

export const InputLabel = styled.span`
  color: ${colors.gray4};
  display: block;
  letter-spacing: 0.76px;
  line-height: 100%;
  margin-bottom: 5px;
`

export const ModalInput = styled.input`
  background-color: white;
  border: none;
  border-bottom: 1px solid ${props => props.color || colors.gray2};
  color: ${colors.blue3};
  display: block;
  height: 36px;
  outline: none;
  padding: 0 10px;
  width: 100%;

  &::placeholder {
    font-weight: normal;
  }

  &:disabled,
  &:disabled::placeholder {
    color: ${rgba(colors.gray6, 0.36)};
  }

  &:focus {
    border-bottom-color: ${colors.caribbean};
  }

  &.error {
    color: ${colors.red};
    border-bottom-color: ${colors.red};

    &:focus {
      border-bottom-color: ${colors.red};
    }
  }
`
